<div class="container" >

    <div class="headings">
        <span class="hr"></span>
        <h1>Locations</h1>
        <span class="hr"></span>
    </div>
    <div class="row">
        <app-card class="col-sm-6" *ngFor="let location of locations" [location]="location"></app-card> 
    </div>
</div>